import React from 'react';
import PropTypes from 'prop-types';
import '../styles/about.css';
import rigel from '../assets/images/rigel.png';
import { GithubIcon, FacebookIcon, LinkedinIcon } from "../assets/svg";
import resume from '../assets/files/RigelJohnJamon_Resume.pdf'
const About = (props,{id}) => {
  const handleDownloadResume = () => {
    // Trigger download by creating an anchor element and simulating click
    const link = document.createElement('a');
    link.href = resume;
    link.download = 'RigelJohnJamon_Resume.pdf';
    link.click();
  };
  return (
    <div className="about-about" id="about">
      <img alt={props.imageAlt} src={props.imageSrc} className="about-image" />
      <div className="about-container">
        <h1 className="about-text">
          <span className="about-text01">Rigel John Jamon</span>
          <span> </span>
        </h1>
        <p className="about-text03">{props.heading}</p>
        <span className="about-text04"></span>
        <div className="about-btn-group">
        <div className="icon-group">
        <a  className="icon" href="https://github.com/rigeljohn" target="_blank" rel="noreferrer">
          <i >
            <GithubIcon color="black"/>
          </i>
        </a>
        <a  className="icon" href="https://www.facebook.com/rigeljohn.jamon.7/" target="_blank" rel="noreferrer">
          <i >
            <FacebookIcon  color="black" />
          </i>
        </a>
        <a   className="icon" href="https://www.linkedin.com/in/rigeljohnjamon" target="_blank" rel="noreferrer">
          <i >
            <LinkedinIcon color="black"  />
          </i>
        </a>
      </div>
          <button className="about-button1 button" onClick={handleDownloadResume}>
            <span>
              <span>Download Resume</span>
              <br />
            </span>
          </button>
        </div>
      </div>
    </div>
  );
};

About.defaultProps = {
  imageSrc: rigel,
  imageAlt: 'image',
  heading:
    'As a Skilled Web Developer I specialize in Creating Innovative solutions to solve intricate business dilemmas. I excel in both collaborative and independent work environments. readily adapting to various project dynamics and settings',

};

About.propTypes = {
  imageSrc: PropTypes.string,
  imageAlt: PropTypes.string,
  heading: PropTypes.string,
  button: PropTypes.string,
};

export default About;
